export default "__VITE_ASSET__CiePGiYI__"